import React, { FC, useEffect } from 'react';

import useLocation from '../../contrib/Hooks/useLocation.hook';
import { useRouteInfoDispatch, useRouteInfoState } from './Context/RouteInfo.context';
import { matchSetter } from './Utils/matchSetter';

const RouteInfo: FC = () => {
  const { location } = useLocation();

  const {
    actions: { setClubId, setEventId, setRoundId }
  } = useRouteInfoDispatch();

  const { clubId, eventId, roundId } = useRouteInfoState();

  useEffect(() => {
    matchSetter('club', setClubId, clubId, location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    matchSetter('event|event-scores', setEventId, eventId, location.pathname, 'event');
  }, [location.pathname]);

  useEffect(() => {
    matchSetter('round', setRoundId, roundId, location.pathname);
  }, [location.pathname]);

  return <></>;
};

export default RouteInfo;
